export const modalDataAPIs: Item[] = [
  {
    id: 1,
    content:
      "NASA Astronomy Picture of the Day, pictures taken by Mars Rovers and Mars Weather Conditions are taken from from: ",
    link: "https://api.nasa.gov",
    label: "NASA APIs",
  },
  {id: 2, content: "Maps of Mars are provided by: ", link: "https://www.openplanetary.org", label: "OpenPlanetary.org"},
  {
    id: 3,
    content: "World Imagery is provided by: ",
    link: "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer",
    label: "ArcGIS",
  },
  {
    id: 4,
    content: "Local weather conditions are provided by: ",
    link: "https://openweathermap.org",
    label: "OpenWeatherMap",
  },
  {
    id: 5,
    content: "Mars Imagery is provided by: ",
    link: "https://www.usgs.gov/centers/astrogeology-science-center/maps",
    label: "USGS - Astrogeology Science Center",
  },
  {
    id: 6,
    content: "Covid Data is provided by: ",
    link: "https://github.com/mathdroid/covid-19-api",
    label: "mathdroid/covid-19-api",
  },
  {
    id: 7,
    content: "Currency Exchange Rates are provided by: ",
    link: "https://www.exchangerate-api.com",
    label: "ExchangeRate-API",
  },
  {
    id: 8,
    content: "IP Geolocation API is provided by: ",
    link: "https://ipwhois.io",
    label: "IPWHOIS.IO",
  },
  // {id:9}, //* Earth Maps: in the CreditsModal.tsx
];

export const modalDataOther: Item[] = [
  {
    id: 1,
    content: "Nasa's Mars Lander and Rovers transparent icons were taken from: ",
    link: "https://www.pngaaa.com",
    label: "PngAAA.com",
  },
  {
    id: 2,
    content: "Wind Direction Icon was taken from: ",
    link: "https://www.flaticon.com/free-icons/direction",
    label: "flaticon.com",
  },
  {
    id: 3,
    content: "Nasa Mars 3D .glb Model was taken from: ",
    link: "https://solarsystem.nasa.gov/resources/2372/mars-3d-model",
    label: "Nasa - Solar System Exploration",
  },
  // {id: 4}, //* NASA and Wikipedia: in the CreditsModal.tsx
];

export const modalDataLibraries: Item[] = [
  {
    id: 1,
    content: "UI components are taken from: ",
    link: "https://react-bootstrap.github.io",
    label: "React Bootstrap",
  },
  {
    id: 2,
    content: "Fetching data is done by using : ",
    link: "https://axios-http.com",
    label: "Axios",
  },
  {
    id: 3,
    content: "Charts are rendered by: ",
    link: "https://www.chartjs.org",
    label: "Chart.js",
  },
  {
    id: 4,
    content: "Client-side routing is done using: ",
    link: "https://v5.reactrouter.com",
    label: "React Router",
  },
  {
    id: 5,
    content: "Table is generated using: ",
    link: "https://react-table.tanstack.com",
    label: "React Table",
  },
  {
    id: 6,
    content: "Global state of the App is maintained by: ",
    link: "https://redux.js.org",
    label: "Redux",
  },
  {
    id: 7,
    content: "Nasa Mars 3D .glb Model is generated using: ",
    link: "https://threejs.org",
    label: "Three.js",
  },
  //* More libraries in the CreditsModal.tsx
];

export const modalDataLibraries2: {
  id: number;
  link_1: string;
  link_2: string;
  label_1: string;
  label_2: string;
  content: string;
}[] = [
  {
    id: 11,
    link_1: "https://www.typescriptlang.org",
    label_1: "TypeScript",
    link_2: "https://reactjs.org",
    label_2: "React",
    content: "are used to built the App.",
  },
  {
    id: 12,
    link_1: "https://cesium.com",
    label_1: "Cesium",
    link_2: "https://resium.reearth.io",
    label_2: "Resium",
    content: "are used to render the 3D model of Mars.",
  },
  {
    id: 13,
    link_1: "https://leafletjs.com",
    label_1: "Leaflet",
    link_2: "https://openlayers.org",
    label_2: "OpenLayers",
    content: "are used to render 2D maps of Earth and Mars.",
  },
  {
    id: 14,
    link_1: "https://styled-components.com",
    label_1: "Styled-Components",
    link_2: "https://sass-lang.com",
    label_2: "Sass",
    content: "are used to customize the UI.",
  },
  {
    id: 15,
    link_1: "https://github.com/framer/motion",
    label_1: "Framer Motion",
    link_2: "https://react-spring.io",
    label_2: "React-Spring",
    content: "are used to generate the animations.",
  },
];
